<template>
  <div class="cidade-atendida">
    <CidadeComp />
</div>
</template>

<script>

import CidadeComp from '@/components/CidadeComp.vue'

export default {
  name: 'CidadeView',
  components: {
    CidadeComp
  }
}
</script>
